// Response shape of GET /provider/analytics — one payload feeds both the
// Dashboard and the Analytics screen.
export interface ProviderAnalyticsResponse {
    org: {
        displayName: string
        seatQuota: number
        seatsUsed: number
        seatsActive: number
    }
    kpis: {
        weeklyActiveFamilies: number
        biweeklyActiveFamilies: number
        onboardingCompletionRate: number
        avgChatsPerActiveFamily: number
        avgMilestonesCompleted: number
        homeworkOutstanding: number
        homeworkCompletedThisWeek: number
        consentRate: number
    }
    funnel: {
        invited: number
        registered: number
        onboarded: number
        startedRoadmap: number
        firstMilestone: number
    }
    weeklyActiveTrend: { weekStart: string; count: number }[]
    topResources: { title: string; families: number }[]
    needsAttention: {
        overdueHomework: {
            licenseId: string
            homeworkId: string
            childName: string | null
            title: string
            dueDate: string
        }[]
        stalledInvites: { licenseId: string; email: string; invitedAt: string }[]
    }
    recentActivity: {
        text: string
        ts: string
        type: 'activation' | 'homework' | 'note'
        licenseId: string
        homeworkId?: string
    }[]
    // Analytics groups. Coordinator-performance / capacity / population / outcome
    // sections render from these; the dashboard folds in the old standalone
    // Analytics page. WoW-history fields are null/empty until the backend tracks
    // history (never fabricated).
    coordinatorPerformance: {
        userId: string
        name: string
        caseload: number
        capacity: number
        engagementRate: number
        atRisk: number
    }[]
    capacity: {
        familiesPerCoordinator: number
        familiesPerCoordinatorPrev: number | null
        familiesPerCoordinatorTrend: number[]
        selfServiceRate: number
        touchesPerFamily: number
        touchesPerFamilyPrev: number | null
    }
    population: {
        careGaps: { label: string; count: number }[]
        serviceAccessProgress: number
        atRiskByNeed: { need: string; count: number }[]
    }
    familyOutcomes: {
        engagementRate: number
        roadmapProgress: number
        atRiskCount: number
        atRiskPct: number
    }
}

export function formatShortDate(value?: string | null) {
    if (!value) return null
    const d = new Date(value)
    if (isNaN(d.valueOf())) return null
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
}
